// In FixedAssetDamageForm.js
import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography } from "antd";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const FixedAssetDamageForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;  // Add this line to get the edit mode

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        percArea: props.record.damage.percArea,
        size: props.record.damage.size
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.percArea = elvis(values.percArea);
    newDamage.damage.size = elvis(values.size);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="fixedAssetDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Element"
      />
      <Form.Item label="Damaged area (%)" name="percArea">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Extension of the damage (ha)" name="size">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default FixedAssetDamageForm;